// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3_YkJ","notes":"Notes_notes__m8eXG"};